// TODO: update before the event start
export const EVENT_DOCUMENTATION_LINK = "https://docs.palmswap.org/ecosystem/trade-2-earn";
